// extracted by mini-css-extract-plugin
export default {"wrapper":"Image_wrapper__y4r3W","img":"Image_img__0XW8E","skeleton":"Image_skeleton__0bPeq"};